import { render, staticRenderFns } from "./AskingQuestions.vue?vue&type=template&id=51479e00&scoped=true"
import script from "./AskingQuestions.vue?vue&type=script&lang=js"
export * from "./AskingQuestions.vue?vue&type=script&lang=js"
import style0 from "./AskingQuestions.vue?vue&type=style&index=0&id=51479e00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51479e00",
  null
  
)

export default component.exports